import React from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { responsive } from "../../utils/style";

const QuizContainer = ({ children }) => {
  return (
    <Container>
      <Background>{children}</Background>
    </Container>
  );
};

export default QuizContainer;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  width: 100%;
  background-color: #fffbeb;
`;

const Background = styled.div`
  width: 100%;
  max-width: 1144px;
  background-color: white;
  padding: 40px 116px;
  margin: auto;
  min-height: 100vh;

  ${responsive.tablet(css`
    padding: 40px 87px;
    max-width: unset;
  `)}

  ${responsive.mobile(css`
    padding: 24px 16px;
  `)}
`;
